import "core-js/modules/es.array.concat.js";
import styled from 'styled-components';
import { textLinkStyles } from 'components/TextLink';
import { HEADING_SIZES } from 'components/Heading';
import { overflowWrap } from 'styles/mixins';
function getHeadingStyles(headingSize) {
  return function (props) {
    var _props$theme$globals = props.theme.globals,
      typeScale = _props$theme$globals.typeScale,
      breakpoints = _props$theme$globals.breakpoints;
    return "\n\t\tfont-size: ".concat(typeScale[HEADING_SIZES[headingSize][0]], ";\n\n\t\t@media (min-width: ").concat(breakpoints.m, ") {\n\t\t\tfont-size: ").concat(typeScale[HEADING_SIZES[headingSize][1]], ";\n\t\t}\n\t");
  };
}

/**
 * Adds formatting to HTML that's generated from markdown.
 * This is necessary because our CSS reset removed those basic text
 * styles for ease of customisation.
 *
 * Currently supports links, lists, and headings.
 * Bold/italic text formatting is preserved by our reset so did not
 * need to be added here.
 */

var FormattedText = styled.div.withConfig({
  displayName: "FormattedText",
  componentId: "sc-gl0mlk-0"
})(["& > * + *{margin-top:", ";}a{", "}ul,ol{list-style:revert;padding-inline-start:", ";}h1,h2,h3,h4,h5{line-height:1.25;font-weight:bold;", "}h1{", "}h2{", "}h3,h4,h5{", "}"], function (p) {
  return p.theme.globals.spacing.s;
}, textLinkStyles, function (p) {
  return p.theme.globals.spacing.l;
}, overflowWrap, getHeadingStyles('medium'), getHeadingStyles('small'), getHeadingStyles('extra-small'));
export default FormattedText;